// Turning structured narrations and warning lines into text (strings live in ui/text/en.ts).
import type { Narration } from '../../sim/api';
import type { WarningLine } from '../../viewModels';
import { jobLabel } from '../../viewModels';
import { humanize, seasonName, template } from '../format';
import { fill, narration as narrationText, resourceLabel, uiText } from '../text/en';

/** A narration as a sentence; unknown template ids fall back to their params. */
export function narrationLine(n: Narration): string {
  if (!(n.template in narrationText)) return `${humanize(n.template)}.`;
  const out = fill(n, jobLabel);
  // Event ids read better humanised until the events stream adds labels.
  return typeof n.params.event === 'string' ? out.replace(n.params.event, humanize(n.params.event)) : out;
}

function liveParams(params: WarningLine['params']): Record<string, string | number> {
  const out: Record<string, string | number> = { ...params };
  const r = params.resource;
  if (typeof r === 'string')
    out.resource = ((resourceLabel as Record<string, string | undefined>)[r] ?? r).toLowerCase();
  const s = params.season;
  if (s === 'spring' || s === 'summer' || s === 'autumn' || s === 'winter') out.season = seasonName(s);
  return out;
}

export function warningLine(w: WarningLine): string {
  if (w.template.startsWith('live.')) {
    const text = uiText.liveWarning[w.template as keyof typeof uiText.liveWarning];
    return template(text, liveParams(w.params));
  }
  return narrationLine({ template: w.template as Narration['template'], params: w.params });
}
